/* =========================================================
   랜딩 유입 추적 — 어느 채널 · 어느 세그먼트에서 왔는지
   - 랜딩 주소의 utm_* 파라미터(또는 외부 리퍼러)를 브라우저에 30일 보관한다.
     나중에 직접 들어와 문의해도 처음 데려온 채널이 문의에 함께 기록된다.
   - 새 utm 이 붙어 들어오면 덮어쓴다(마지막으로 데려온 채널 기준).
   - 방문은 세션마다 페이지당 한 번만 /api/landing/visit 로 보낸다.
   저장소가 막힌 브라우저(사생활 보호 모드 등)에서도 페이지는 그대로 동작해야 한다.
   ========================================================= */

const ATTR_KEY = "imeta_landing_attr";
const SEG_KEY = "imeta_landing_segment";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

function readJson(storage, key) {
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeJson(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    /* 저장할 수 없으면 이번 방문만 추적하지 않는다 */
  }
}

/* 외부 사이트에서 넘어왔으면 그 호스트, 아니면 null */
function externalReferrer() {
  try {
    if (!document.referrer) return null;
    const host = new URL(document.referrer).hostname;
    return host && host !== window.location.hostname ? host : null;
  } catch {
    return null;
  }
}

/* 주소의 utm 파라미터 · 외부 리퍼러를 저장하고 이번 방문의 유입 정보를 돌려준다. */
export function captureAttribution(search) {
  const p = new URLSearchParams(search);
  const source = p.get("utm_source");
  let attr = null;

  if (source) {
    attr = {
      source,
      medium: p.get("utm_medium") || "",
      campaign: p.get("utm_campaign") || "",
      content: p.get("utm_content") || "",
      referrer: document.referrer || "",
    };
  } else {
    const host = externalReferrer();
    if (host) attr = { source: host, medium: "referral", campaign: "", content: "", referrer: document.referrer };
  }

  if (attr) {
    writeJson(window.localStorage, ATTR_KEY, { ...attr, at: Date.now() });
    return attr;
  }
  return getAttribution();
}

/* 저장된 유입 정보 — 없거나 30일이 지났으면 direct */
export function getAttribution() {
  const saved = readJson(window.localStorage, ATTR_KEY);
  if (saved && Date.now() - (saved.at || 0) < TTL_MS) return saved;
  return { source: "direct", medium: "", campaign: "", content: "", referrer: "" };
}

/* 마지막으로 본 세그먼트 랜딩 — 문의 페이지에 from 이 없을 때 쓴다 */
export function rememberSegment(slug) {
  writeJson(window.localStorage, SEG_KEY, { slug, at: Date.now() });
}

export function lastSegment() {
  const saved = readJson(window.localStorage, SEG_KEY);
  return saved && Date.now() - (saved.at || 0) < TTL_MS ? saved.slug : "";
}

/* 랜딩 · 허브 · 문의 페이지가 열릴 때 부른다.
   유입 정보를 먼저 저장하고, 방문은 같은 세션에서 페이지당 한 번만 기록한다.
   (자식 컴포넌트 effect 가 레이아웃보다 먼저 돌기 때문에 저장도 여기서 한다) */
export function trackVisit(segment) {
  captureAttribution(window.location.search);
  const flag = `imeta_visit_${segment}`;
  try {
    if (window.sessionStorage.getItem(flag)) return;
    window.sessionStorage.setItem(flag, "1");
  } catch {
    /* 세션 저장소가 없으면 중복될 수 있지만 기록은 한다 */
  }

  const a = getAttribution();
  const body = JSON.stringify({
    segment,
    source: a.source,
    medium: a.medium,
    campaign: a.campaign,
    content: a.content,
  });
  fetch("/api/landing/visit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}
